import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/working-capital',
  component: () => import('../../routes/WorkingCapital.svelte'),
  card: {
    id: 'working-capital',
    title: 'Working Capital Calculator',
    description: 'Measure your business short-term financial health by calculating working capital and liquidity ratios.',
    icon: 'account_balance',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/working-capital',
    category: 'Business',
  },
  seo: {
    title: 'Working Capital Calculator – Business Liquidity Calculator',
    description: 'Free working capital calculator to measure business liquidity. Calculate working capital, current ratio, quick ratio, and cash ratio. Assess your company short-term financial health instantly.',
  },
};

export default meta;
